/* eslint-disable */
export default {
  order: 3,
  header: [
    {
      category: 'Overview',
      item: [
        {
          title: '',
          list: [
            {
              name: 'What is EnOS',
              url: '/docs/enos/en/2.4.4/overview/enos_introduction.html'
            },
            {
              name: 'EnOS Advantages',
              url: '/docs/enos/en/2.4.4/overview/advantage.html'
            },
            {
              name: 'Key Concepts',
              url: '/docs/enos/en/2.4.4/overview/concepts.html'
            }
          ]
        }
      ],
      layout: 'vertical',
      showListInMobile: true
    },
    {
      category: 'Product Documentation',
      item: [
        {
          title: 'Application Building',
          list: [
            {
              name: 'Application Portal',
              url: '/docs/app-portal/en/2.4.4/overview.html'
            },
            {
              name: 'EnOS Mobile',
              url: '/docs/maf/en/2.4.4/intro/overview.html'
            },
            {
              name: 'Digital Twin Visualization',
              url: '/docs/dtv/en/2.4.4/overview.html'
            },
            {
              name: 'Unified Monitoring',
              url: '/docs/monitor/en/2.4.4/overview/monitor_overview.html'
            },
            {
              name: 'Reporting Tool',
              url: '/docs/reporting/en/2.4.4/overview.html'
            },
            {
              name: 'Work Management',
              url: '/docs/wmt/en/2.4.4/about.html'
            },
            {
              name: 'Fleet Control',
              url: '/docs/control/en/2.4.4/overview.html'
            },
            {
              name: 'Metric Management',
              url: '/docs/metric-management/en/2.4.4/overview/metrics_overview.html'
            }
          ]
        },
        {
          title: 'Data Management',
          list: [
            {
              name: 'Time Series Data Management',
              url: '/docs/time-series-data/en/2.4.4/overview.html'
            },
            {
              name: 'Common Data Service',
              url: '/docs/cds/en/2.4.4/overview.html'
            },
            {
              name: 'Data Subscription',
              url: '/docs/data-subscription/en/2.4.4/data_subscription_overview.html'
            },
            {
              name: 'Data Archiving',
              url: '/docs/data-archiving/en/2.4.4/archive_policy.html'
            },
            {
              name: 'Data Source Registration',
              url: '/docs/data-source-reg/en/2.4.4/datasource_overview.html'
            }
          ]
        },
        {
          title: 'Device Connection',
          list: [
            {
              name: 'Device Connection',
              url: '/docs/device-connection/en/2.4.4/learn/message_flow.html'
            },
            {
              name: 'Device Management',
              url: '/docs/device-connection/en/2.4.4/learn/device_lifecycle_management.html'
            },
            {
              name: 'Device Data Integration Service',
              url: '/docs/device-integration/en/2.4.4/learn/device_integration_overview.html'
            },
            {
              name: 'Alarm Management',
              url: '/docs/alarm-management/en/2.4.4/overview/about.html'
            },
            {
              name: 'Alert Engine',
              url: '/docs/alert/en/2.4.4/learn/alert_overview.html'
            },
            {
              name: 'Data Quality',
              url: '/docs/data-quality/en/2.4.4/overview/about.html'
            },
            {
              name: 'Device Provisioning Service',
              url: '/docs/device-provisioning/en/2.4.4/overview/about.html'
            },
            {
              name: 'EnOS Edge',
              url: '/docs/enos-edge/en/2.4.4/edge_overview.html'
            }
          ]
        }
      ],
      layout: 'vertical',
      footer: {
        name: 'View all products',
        image: 'assets/images/header/document_center.svg',
        url: '/docs/en/2.4.4'
      },
      showListInMobile: false
    },
    {
      category: 'Tutorials',
      item: [
        {
          title: 'Data Integration',
          list: [
            {
              name: 'Connecting a Simulated Device to EnOS Cloud',
              url: '/docs/device-connection/en/2.4.4/tutorial/connecting_device_simulated/index.html'
            },
            {
              name: 'Connecting a Simulated Electricity Meter to EnOS Edge',
              url: '/docs/enos-edge/en/2.4.4/tutorial/connecting_edge.html'
            },
            {
              name: 'Integrating PC Device Data',
              url: '/docs/device-integration/en/2.4.4/howto/tutorial_pc_device_mgmt.html'
            }
          ]
        },
        {
          title: 'Data Development',
          list: [
            {
              name: 'Assessing Data Quality of the Wind Turbine',
              url: '/docs/data-quality/en/2.4.4/tutorial.html'
            },
            {
              name: 'Developing Metrics of Solar Generation, Temperature, and Radiance',
              url: '/docs/metric-management/en/2.4.4/tutorial/index.html'
            },
            {
              name: 'Customizing Production(SPLM) Metric for Solar Sites',
              url: '/docs/cds/en/2.4.4/tutorial/tutorial_solar.html'
            }
          ]
        },
        {
          title: 'Application Development',
          list: [
            {
              name: 'Creating Applications Using Common Building Blocks',
              url: '/docs/app-development/en/2.4.4/app_dev_workflow/index.html'
            },
            {
              name: 'Building a Smart Battery Dashboard',
              url: '/docs/dtv/en/2.4.4/tutorial/index.html'
            },
            {
              name: 'Building a Water Purification System Monitoring Page',
              url: '/docs/dtv/en/2.4.4/tutorial/monitor.html'
            }
          ]
        }
      ],
      layout: 'horizontal',
      footer: {
        name: 'View all tutorials',
        image: 'assets/images/header/tutorial_center.svg',
        url: '/docs/en/2.4.4/tutorial'
      },
      showListInMobile: false
    },
    {
      category: 'Resources',
      item: [
        {
          title: '',
          list: [
            {
              name: 'EnOS APIs',
              url: 'https://developer.enos-iot.com/enos-apis/'
            },
            {
              name: 'SDKs and Tools',
              url: 'https://developer.enos-iot.com/enos-sdks-tools/'
            }
          ]
        }
      ],
      layout: 'vertical',
      showListInMobile: true
    }
  ],
  content: [
    {
      category: 'Data Integration',
      item: [
        {
          name: 'Connecting a Simulated Device to EnOS Cloud',
          description: 'Estimated Time: 80 mins',
          image: 'assets/images/tutorial/tutorial.png',
          url: '/docs/device-connection/en/2.4.4/tutorial/connecting_device_simulated/index.html'
        },
        {
          name: 'Connecting a PC to EnOS Cloud',
          description: 'Estimated Time: 110 mins',
          image: 'assets/images/tutorial/tutorial.png',
          url: '/docs/device-connection/en/2.4.4/tutorial/connecting_pc/index.html'
        },
        {
          name: 'Connecting a Simulated Electricity Meter to EnOS Edge',
          description: 'Estimated Time: 40 mins',
          image: 'assets/images/tutorial/tutorial.png',
          url: '/docs/enos-edge/en/2.4.4/tutorial/connecting_edge.html'
        },
        {
          name: 'Integrating PC Device Data',
          description: 'Estimated Time: 40 mins',
          image: 'assets/images/tutorial/dis_en.png',
          url: '/docs/device-integration/en/2.4.4/howto/tutorial_pc_device_mgmt.html'
        }
      ]
    },
    {
      category: 'Data Development',
      item: [
        {
          name: 'Assessing Data Quality of the Wind Turbine',
          description: 'Estimated Time: 30 mins',
          image: 'assets/images/tutorial/quality_en.png',
          url: '/docs/data-quality/en/2.4.4/tutorial.html'
        },
        {
          name: 'Developing Metrics of Solar Generation, Temperature, and Radiance',
          description: 'Estimated Time: 120 mins',
          image: 'assets/images/tutorial/metric_en.png',
          url: '/docs/metric-management/en/2.4.4/tutorial/index.html'
        },
        {
          name: 'Customizing Production(SPLM) Metric for Solar Sites',
          description: 'Estimated Time: 60 mins',
          image: 'assets/images/tutorial/tutorial.png',
          url: '/docs/cds/en/2.4.4/tutorial/tutorial_solar.html'
        }
      ]
    },
    {
      category: 'Application Development',
      item: [
        {
          name: 'Registering and Managing Applications',
          description: 'Estimated Time: 40 mins',
          image: 'assets/images/tutorial/app_en.png',
          url: '/docs/app-development/en/2.4.4/app_management/managing_apps.html'
        },
        {
          name: 'Creating Applications Using Industry Application Common Building Blocks',
          description: 'Estimated Time: 160 mins',
          image: 'assets/images/tutorial/cbb_app_en.png',
          url: '/docs/app-development/en/2.4.4/app_dev_workflow/index.html'
        },
        {
          name: 'Building a Smart Battery Dashboard',
          description: 'Estimated Time: 80 mins',
          image: 'assets/images/tutorial/battery_dashboard_en.png',
          url: '/docs/dtv/en/2.4.4/tutorial/index.html'
        },
        {
          name: 'Building a Water Purification System Monitoring Page',
          description: 'Estimated Time: 80 mins',
          image: 'assets/images/tutorial/water_monitoring_en.png',
          url: '/docs/dtv/en/2.4.4/tutorial/monitor.html'
        }
      ]
    }
  ]
};
